import {IStation} from '../../../api/api.types';
import {IStationApi} from '../../../api/station-api.service';

export default class ForecastingTableController {
    static $inject = ['stationApi', '$scope'];

    stations:IStation[];
    selectedStation:IStation;
    stationsPromise:ng.IPromise<void>;

    isOpen:boolean = false;

    constructor(private stationApi:IStationApi, private $scope: ng.IScope) {
      this.selectedStation;
      this.stations = [];
      this.stationsPromise = this.stationApi.getDischargeStationsWithForecast()
          .then(this.onStationsReady);

    }

    private onStationsReady = (stations:IStation[]) => {
      this.stations = stations;
      this.selectedStation = this.stations[0];
      this.notifyChanges(this.selectedStation);
    }

    onSelectedStationChange: (callbackArgs: {
	    selectedStation: IStation
	  }) => void;

    private notifyChanges(station: IStation) {
      if (this.onSelectedStationChange ) {
        this.onSelectedStationChange({
          selectedStation: station
        });
      }
    }

    onStationSelected(station: IStation) { 
      this.notifyChanges(this.selectedStation);
    }

}



/** WEBPACK FOOTER **
 ** ./app/hydromet/forecasting/process/forecasting-sites.controller.ts
 **/